namespace TabAurous.ProductDevelopment {
    export interface RequirementItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        Iteration: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        Budget: AmountEditor;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        ToneType: Serenity.EnumEditor;
        DualToneMetalId: Serenity.LookupEditor;
        DualToneKaratId: Serenity.LookupEditor;
        DualToneMetalColorId: Serenity.LookupEditor;
        DualTonePurity: Serenity.DecimalEditor;
        TripleToneMetalId: Serenity.LookupEditor;
        TripleToneKaratId: Serenity.LookupEditor;
        TripleToneMetalColorId: Serenity.LookupEditor;
        TripleTonePurity: Serenity.DecimalEditor;
        CenterStone: Serenity.LookupEditor;
        StoneCategoryId: CommonCategoryLookup;
        StoneSubCategoryId: CommonSubCategoryLookup;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        MappingId: Serenity.LookupEditor;
        StoneItems: RequirementStoneItemsEditor;
        Remark: Serenity.TextAreaEditor;
        SpecialRemark: Serenity.TextAreaEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        Image4: Serenity.ImageUploadEditor;
        Image5: Serenity.ImageUploadEditor;
    }

    export class RequirementItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.RequirementItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RequirementItemsForm.init)  {
                RequirementItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = AmountEditor;
                var w5 = CommonSubCategoryLookup;
                var w6 = s.LookupEditor;
                var w7 = CommonProductSizeLookup;
                var w8 = s.BooleanEditor;
                var w9 = s.DecimalEditor;
                var w10 = s.EnumEditor;
                var w11 = StoneSizeLookup;
                var w12 = RequirementStoneItemsEditor;
                var w13 = s.TextAreaEditor;
                var w14 = s.ImageUploadEditor;

                Q.initFormType(RequirementItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w2,
                    'LedgerName', w0,
                    'PartyCode', w0,
                    'RefNo', w0,
                    'Iteration', w0,
                    'BagNo', w0,
                    'ProductCode', w0,
                    'DesignCode', w0,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'Budget', w4,
                    'SubCategoryId', w5,
                    'BrandId', w6,
                    'SuperTypeId', w6,
                    'CollectionId', w6,
                    'StampId', w6,
                    'ProductSizeId', w7,
                    'HasBom', w8,
                    'MetalId', w6,
                    'Attribute', w0,
                    'KaratId', w6,
                    'MetalColorId', w6,
                    'Purity', w9,
                    'ToneType', w10,
                    'DualToneMetalId', w6,
                    'DualToneKaratId', w6,
                    'DualToneMetalColorId', w6,
                    'DualTonePurity', w9,
                    'TripleToneMetalId', w6,
                    'TripleToneKaratId', w6,
                    'TripleToneMetalColorId', w6,
                    'TripleTonePurity', w9,
                    'CenterStone', w6,
                    'StoneCategoryId', w3,
                    'StoneSubCategoryId', w5,
                    'ShapeId', w6,
                    'StoneColorId', w6,
                    'QualityId', w6,
                    'StoneSizeId', w11,
                    'MappingId', w6,
                    'StoneItems', w12,
                    'Remark', w13,
                    'SpecialRemark', w13,
                    'ImageName', w14,
                    'Image1', w14,
                    'Image2', w14,
                    'Image3', w14,
                    'Image4', w14,
                    'Image5', w14
                ]);
            }
        }
    }
}
